// 9fbef606107a605d69c0edbcd8029e5d
import RemoveCustomerGiftCard from '@tcp/core/src/queries/removeCustomerGiftCard.query.graphql';
import DeleteCustomerPaymentInstrument from '@tcp/core/src/queries/deletePaymentInstrument.query.graphql';
import { executeStatefulGraphQLQuery } from '../../handler';

const getPaymentId = (paymentMethodId) => {
  switch (paymentMethodId) {
    case 'ADSPlaceCard':
      return 'ADS_PLCC';
    default:
      return paymentMethodId;
  }
};

const getResponse = (res) => {
  return {
    res,
    statusCode: 200,
  };
};
export const deleteCardApi = (payload) => {
  const paymentMethodId = getPaymentId(payload?.paymentMethodId);
  const reqObject = {
    deleteCustomerPaymentInstrumentPaymentInstrumentId: payload.creditCardId,
    deleteCustomerPaymentInstrumentPaymentMethodType: paymentMethodId,
  };

  return executeStatefulGraphQLQuery({
    query: DeleteCustomerPaymentInstrument,
    variables: reqObject,
    type: 'mutation',
  })
    .then((response) => {
      return getResponse(response);
    })
    .catch((err) => {
      throw err;
    });
};

export function removeCustomerGiftCard(payload) {
  const reqObject = {
    deleteCustomerGiftCardPaymentInstrumentId: payload.creditCardId,
  };

  return executeStatefulGraphQLQuery({
    query: RemoveCustomerGiftCard,
    variables: reqObject,
    type: 'mutation',
  })
    .then((response) => {
      return getResponse(response);
    })
    .catch((err) => {
      throw err;
    });
}
